import React, { Component } from 'react';
import Typography from 'material-ui/Typography';

class TabContainer extends Component {
    render(){
        return (
            <Typography component="div" style={{ padding: 8 * 2 }}>
                {this.props.children}
            </Typography>
        )
    }
}

export default TabContainer;


// WEBPACK FOOTER //
// ./src/shared/TabContainer/TabContainer.js